import { useCreateRequirementMapping } from "./useCreateRequirementMapping";
import { useUpdateRequirementMapping } from "./useUpdateRequirementMapping";

export function useRequirementMappingApis() {
  const {
    mutateAsync: createRequirementMapping,
    isLoading: isCreatingRequirementMapping,
    error: createRequirementMappingError,
  } = useCreateRequirementMapping();

  const {
    mutateAsync: updateRequirementMapping,
    isLoading: isUpdatingRequirementMapping,
    error: updateRequirementMappingError,
  } = useUpdateRequirementMapping();

  return {
    createRequirementMapping,
    isCreatingRequirementMapping,
    createRequirementMappingError,
    updateRequirementMapping,
    isUpdatingRequirementMapping,
    updateRequirementMappingError,
  };
}
